import{AspectBox as gr}from"@fourthwall/components/dist/common/AspectBox/AspectBox";import{Skeleton as b}from"@fourthwall/components/dist/partials/Skeleton";import d,{memo as xr}from"react";import{Swatch as Dt}from"@fourthwall/components/dist/common/Swatch";import{Tooltip as Ht}from"@fourthwall/components/dist/common/Tooltip";import{Checkbox as Ut}from"@fourthwall/components/dist/inputs/Checkbox";import{Radio as Wt}from"@fourthwall/components/dist/ui/Radio";import{QuestionMarkDarkIcon as Ft,ZoomInIcon as _t}from"@fourthwall/icons";import l from"react";import{Colors as f}from"@fourthwall/components/dist/colors";import{mediaQueries as F}from"@fourthwall/components/dist/providers/MediaQueryProvider";import C,{css as A}from"styled-components";var Co=C.div`
  & > * + * {
    ${({spacing:o=6})=>A`
      margin-top: ${o}px;
    `}}
  }
`,Po=C.div`
  ${({gutter:o=20})=>A`
    margin-left: ${o}px;
    margin-right: ${o}px;
  `}}
`,ho=C.div`
  margin-top: 12px;
`,go=C.p`
  font-size: 14px;
  line-height: 21px;
  color: ${f.GS1000};

  ${F.tablet} {
    font-size: 16px;
    line-height: 24px;

    ${({$size:o})=>o==="compact"&&A`
        font-size: 12px;
        line-height: 16px;
        font-weight: 500;
      `}
  }

  ${({$hoverable:o})=>o&&A`
      &:hover {
        color: ${f.B600};
      }
    `}
`,xo=C.p`
  font-size: 12px;
  line-height: 16px;
  color: ${f.GS600};

  ${F.tablet} {
    font-size: 14px;
    line-height: 21px;
  }
`,vo=C.div`
  display: flex;
  padding: 0;
  gap: 6px;
  flex-wrap: wrap;
`,fo=C.div`
  font-size: 12px;
  line-height: 16px;
  padding: 3px 8px;

  border: 1px solid ${f.GS500};
  border-radius: 100px;
  white-space: nowrap;
  color: ${f.GS600};

  display: flex;
  gap: 8px;
  justify-content: start;
  align-items: center;
`,_=C.p`
  display: flex;
  flex-direction: column;
  vertical-align: center;
  color: ${f.GS600};
  font-size: 12px;
  line-height: 16px;

  ${F.tablet} {
    font-size: 14px;
    line-height: 21px;

    ${({$size:o})=>o==="compact"&&A`
        font-size: 12px;
        line-height: 16px;
        font-weight: 400;
      `}
  }

  & > :not(:first-child) {
    margin-top: 4px;
  }

  @container card (min-width: 300px) {
    flex-direction: row;

    & > :not(:first-child) {
      margin-top: 0;

      &:before {
        content: '';
        display: inline-block;
        vertical-align: middle;
        width: 1px;
        height: 16px;
        background-color: ${f.GS500};
        margin: 0 10px;
      }
    }
  }
`,So=C.div`
  margin-top: 12px;
`,Z=C.div`
  position: relative;
  overflow: hidden;
  padding-bottom: 133%; /* aspect-ratio: 3/4 */

  ${({$outline:o})=>o&&A`
      outline: 1px solid ${f.B500};
    `}
`,K=C.div`
  position: absolute;
  top: 5px;
  left: 5px;

  z-index: 2;

  display: flex;

  > * + * {
    margin-left: 5px;
  }
`,Q=C.span`
  display: none;
  padding: 4px 12px;
  align-items: center;
  gap: 8px;

  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;

  color: ${f.GS1000};

  border-radius: 100px;
  background: ${f.GS0};
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);

  text-align: center;
  white-space: nowrap;

  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: 0.14px;

  cursor: pointer;

  &:hover {
    background: ${f.GS200};
  }
`,q=C.span`
  display: none;

  height: 29px;
  align-content: center;
  color: #000000;
`,j=C.label`
  cursor: pointer;
  height: 29px;

  // this is Ugly - remove when product-customization v1 is deprecated
  ${({$relative:o})=>o&&A`
      position: relative;
    `}

  ${({checked:o,$outline:t})=>o&&t&&A`
      border-color: ${f.B500};
    `}

  &:hover {
    ${Q} {
      display: inline-flex;
    }

    ${q} {
      display: block;
    }
  }
`,Y=C.div`
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 2;

  height: 29px;
  align-content: center;
`,yo=C.span`
  display: inline-flex;
  align-items: center;
`,Vo=C.span`
  color: ${f.GS600};
  margin-left: 4px;
`,bo=C.div`
  display: grid;
  /* 20px = size of the color swatch */
  grid-template-columns: repeat(auto-fit, minmax(20px, min-content));
  gap: 12px;
`;import{Swatch as xt}from"@fourthwall/components/dist/common/Swatch";import X from"react";import{Colors as Ct}from"@fourthwall/components/dist/colors";import J,{css as Pt}from"styled-components";var Bo=J.div`
  display: grid;
  align-items: center;
  grid-template-columns: repeat(auto-fill, 12px);
  gap: 8px;
`,Mo=J.span`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;

  ${({$size:o})=>o==="compact"&&Pt`
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
    `}

  color: ${Ct.GS600};
`,re=J.div`
  width: 12px;
  height: 12px;
  box-shadow: inset 0px 0px 0px 1px ${({light:o})=>o?"#bebebe":"rgba (0, 0, 0, 0)"};
  border-radius: 50%;
`;import{useMemo as gt}from"react";var Ao=4,zo=({colors:o,hiddenColorsCount:t=0})=>{let r=gt(()=>({toShow:o.slice(0,Ao),toCount:o.slice(Ao,o.length)}),[o]),n=r.toCount.length+t;return{limitedColors:r,count:n}};var R=({colors:o,hiddenColorsCount:t,size:r})=>{let{limitedColors:n,count:a}=zo({colors:o,hiddenColorsCount:t});return X.createElement(Bo,null,n.toShow.map(({name:i,swatch:s})=>X.createElement(xt,{key:i,size:"xsmall",fill:s,active:!1})),a>0&&X.createElement(Mo,{$size:r,"data-testid":"AvailableColors.Rest"},"+",a))};import T from"react";import{Colors as ko}from"@fourthwall/components/dist/colors";import{mediaQueries as vt}from"@fourthwall/components/dist/providers/MediaQueryProvider";import y,{css as wo}from"styled-components";var To=y.div`
  position: relative;
  z-index: 0;
`,oo=y.div`
  position: absolute;
  bottom: 4px;
  left: 4px;
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.1s ease-in-out,
    visibility 0.1s ease-in-out;
`,to=y.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
`,ro=y.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: none;
`,$o=y.div`
  position: relative;
  z-index: 0;

  & > * + * {
    margin-top: 12px;
  }

  &:hover {
    ${({compact:o})=>o&&wo`
        ${oo} {
          opacity: 1;
          visibility: visible;
        }

        ${to} {
          display: none;
        }

        ${ro} {
          display: block;
        }
      `}
  }
`,eo=y.div`
  position: absolute;
  top: 0;
  z-index: 1;
  width: 100%;
  display: none;
`,Io=y.div`
  position: relative;
  z-index: 0;
`,no=y.div`
  position: absolute;
  top: -16px;
  left: -16px;
  z-index: -1;
  width: calc(100% + 32px);
  height: calc(100% + 32px);
  display: none;
  background-color: ${ko.GS0};
`,io=y.div`
  position: absolute;
  top: 0;
  left: -16px;
  z-index: -1;
  width: calc(100% + 32px);
  height: calc(100% + 16px);
  display: none;
  background-color: ${ko.GS0};
`,No=y.div`
  container: card / inline-size;
  user-select: none;
  position: relative;
  z-index: 0;
  display: block;

  ${({$interactive:o})=>o&&wo`
      ${vt.laptop} {
        &:hover {
          z-index: 1;

          ${no},
          ${io},
          ${eo} {
            display: block;
          }
        }
      }
    `}
`;var x=({interactive:o=!0,children:t})=>T.createElement(No,{$interactive:o},T.createElement(To,null,t,T.createElement(no,null))),St=({children:o,compact:t,onMouseEnter:r,onMouseLeave:n})=>T.createElement($o,{onMouseEnter:r,onMouseLeave:n,compact:t},o),yt=({children:o})=>T.createElement(eo,null,o,T.createElement(io,null)),Vt=({children:o})=>T.createElement(Io,null,o);x.Content=St;x.ContentOnMouseEnter=yt;x.ContentOnMouseLeave=Vt;x.ColorsCountBadge=oo;x.Image=to;x.ImageSecond=ro;import bt from"lodash-es/debounce";import{useRef as Lo,useState as Bt}from"react";var Mt=500,At=200,ao=(o=!1,t={timeToInteractive:Mt,timeToRespond:At})=>{let r=Lo(null),n=Lo(),[a,i]=Bt(o),s=u=>{let S=bt(u,t.timeToRespond,{leading:!0,trailing:!1});n.current?.cancel(),S(),n.current=S},p=()=>{n.current?.cancel()};return{interactive:a,onInteractivity:u=>{r.current=setTimeout(()=>{u?.(),i(!0)},t.timeToInteractive)},cancelInteractivity:()=>{r.current&&clearTimeout(r.current),p(),i(!1)},debounceInteractivity:s}};import{getPrice as Eo}from"@fourthwall/utils/dist/common";var lo=(o,t)=>o===t?`${Eo(o)}`:`From ${Eo(o)}`;import{Colors as z}from"@fourthwall/components/dist/colors";import{Tooltip as wt}from"@fourthwall/components/dist/common/Tooltip";import Go from"react";import zt,{css as so}from"styled-components";var Oo=zt.span`
  display: block;

  text-align: center;
  font-weight: 600;

  ${({size:o})=>o==="xsmall"?so`
        font-size: 10px;
        line-height: 15px;
        padding: 2px 6px;
        letter-spacing: 0.1em;
      `:o==="small"?so`
        font-size: 12px;
        line-height: 16px;
        padding: 2px 6px;
        letter-spacing: 0.02em;
      `:so`
      font-size: 14px;
      line-height: 16px;
      padding: 4px 10px;
      letter-spacing: 0.02em;
    `}
`;var Tt={dark:z.GS1000,light:z.GS100,primary:z.B500,secondary:z.GS0},$t={dark:z.GS100,light:z.GS600,primary:z.GS100,secondary:z.GS1000},O=({tooltip:o,label:t,type:r="secondary",size:n,borderRadius:a="100px"})=>{let i=Go.createElement(Oo,{size:n,style:{backgroundColor:Tt[r],color:$t[r],borderRadius:a}},t);return o?Go.createElement(wt,{reference:i,strategy:"fixed",fluid:!0},o):i};import Lt,{createContext as Et,useContext as Ot,useMemo as Gt}from"react";import{useEffect as It,useState as Nt}from"react";var Do=(o,t)=>{let[r,n]=Nt(t??o[0]),a=s=>o.find(p=>p.color.swatch===s),i=s=>{let p=a(s)??o[0];n(p)};return It(()=>{let s=o.some(p=>p.color.name===t?.color.name)?t:o[0];s&&n(s)},[t,o]),{activeColorVariant:r,setActiveColorVariant:n,getColorVariantByColorValue:a,setActiveColorVariantByColorValue:i}};var Ho=Et(void 0),Ie=({colorVariants:o,initialColorVariant:t,children:r})=>{let{activeColorVariant:n,setActiveColorVariant:a,getColorVariantByColorValue:i,setActiveColorVariantByColorValue:s}=Do(o,t??o[0]),p=Gt(()=>({colorVariants:o,activeColorVariant:n,setActiveColorVariant:a,getColorVariantByColorValue:i,setActiveColorVariantByColorValue:s}),[o,n,a,i,s]);return Lt.createElement(Ho.Provider,{value:p},r)};function $(){let o=Ot(Ho);if(o===void 0)throw new Error("useProductColorVariantContext must be used within a ProductColorVariantProvider");return o}var Uo=(o,t)=>{let r=Array.from(t).reduce((i,s)=>i+s.charCodeAt(0),0),n=r%o,a=r*31%o;return o>1&&a===n&&(a=(n+1)%o),{randomNumberOne:n,randomNumberTwo:a}};var e=({interactive:o,children:t})=>l.createElement(x,{interactive:o},t),Zt=({children:o,compact:t})=>{let{onInteractivity:r,cancelInteractivity:n}=ao(),a=()=>{r()},i=()=>{n()};return l.createElement(x.Content,{onMouseEnter:a,onMouseLeave:i,compact:t},o)},Kt=({children:o,spacing:t=6})=>l.createElement(Co,{spacing:t},o),Qt=({children:o,gutter:t=20})=>l.createElement(Po,{gutter:t},o),qt=({children:o})=>l.createElement(xo,null,o),jt=({price:o,minimum:t,size:r})=>l.createElement(_,{$size:r},l.createElement("span",null,lo(o.from.value,o.to.value)),l.createElement(Wo,{quantity:t})),Yt=({price:o,size:t})=>l.createElement(_,{$size:t},l.createElement("span",null,lo(o.from.value,o.to.value))),Jt=({children:o})=>l.createElement(So,null,o),Xt=({colorsAvailable:o,colorsOther:t,size:r})=>{let{colorVariants:n}=$();return n.length===1?null:l.createElement(R,{colors:o,hiddenColorsCount:t.length,size:r})},Rt=({children:o})=>l.createElement(x.ContentOnMouseEnter,null,o),or=({children:o})=>l.createElement(ho,null,l.createElement(x.ContentOnMouseLeave,null,o)),tr=()=>{let{colorVariants:o,activeColorVariant:t,setActiveColorVariantByColorValue:r}=$(),{debounceInteractivity:n}=ao(),a=i=>{n(()=>{r(i.swatch)})};return o.length<=1?null:l.createElement(bo,null,o.map(({color:i})=>l.createElement(Dt,{key:i.name,size:"medium",variant:"selectable",fill:i.swatch,active:i.name===t.color.name,onMouseEnter:()=>{a(i)}})))},rr=({checked:o,name:t,value:r,label:n,showLabelOnHover:a=!1,relative:i=!1,outline:s,children:p,onChange:m})=>l.createElement(j,{checked:o,"aria-label":n,"aria-checked":o,$outline:s,$relative:i},l.createElement(Y,null,l.createElement(Ut,{name:t,value:r,checked:o,native:!0,onChange:m,label:l.createElement(q,null,a&&(o?"":"Add\xA0product"))})),p),er=({checked:o,name:t,value:r,label:n,children:a,onChange:i})=>l.createElement(j,{checked:o,"aria-label":n,"aria-checked":o},l.createElement(Y,null,l.createElement(Wt,{name:t,value:r,checked:o,onChange:i})),a),nr=({badges:o,alt:t,outline:r})=>{let{activeColorVariant:n}=$();return l.createElement(Z,{$outline:r,compact:!1},l.createElement(K,null,o.map(a=>l.createElement(O,{key:a.label,...a,size:"small"}))),l.createElement(x.Image,{src:n.photoUrl,alt:t}))},ir=({badges:o,alt:t,outline:r,seed:n})=>{let{colorVariants:a}=$(),i=a.length,{randomNumberOne:s,randomNumberTwo:p}=Uo(i,n);return l.createElement(Z,{$outline:r,compact:!0},l.createElement(K,null,o.map(m=>l.createElement(O,{key:m.label,...m,size:"small"}))),l.createElement(x.Image,{src:a[s].photoUrl,alt:t}),l.createElement(x.ImageSecond,{src:a[p].photoUrl,alt:t}),i>1&&l.createElement(x.ColorsCountBadge,null,l.createElement(O,{label:`${i} colors`,type:"light",size:"small",borderRadius:"4px"})))},Wo=({quantity:o})=>o?l.createElement(yo,null,"minimum ",o,l.createElement(Vo,null,l.createElement(Ht,{reference:l.createElement(Ft,{width:14})},l.createElement("span",null,"This product has a minimum order requirement of ",o,". You can reach the minimum by collecting pre-orders (no upfront payment required).")))):l.createElement("span",null,"no minimum"),ar=({children:o})=>l.createElement(vo,null,o),dr=({children:o,onClick:t})=>l.createElement(fo,{onClick:t},o),lr=({onClick:o})=>l.createElement(Q,{onClick:o},l.createElement(_t,{width:14,height:14}),"Zoom in");e.Label=rr;e.ZoomInButton=lr;e.Radio=er;e.Body=Zt;e.Space=Kt;e.HorizontalGutter=Qt;e.Brand=qt;e.Name=go;e.Price=jt;e.PriceCompact=Yt;e.Pills=ar;e.Pill=dr;e.Details=Jt;e.AvailableColors=Xt;e.ContentOnMouseEnter=Rt;e.ContentOnMouseLeave=or;e.ContentColorway=tr;e.Thumbnail=nr;e.ThumbnailCompact=ir;e.QuantityMessage=Wo;import sr,{createContext as cr,useContext as pr}from"react";var Fo=cr(void 0);function N({href:o,children:t,onClickLink:r}){let n=a=>{r&&r({event:a})};return sr.createElement(Fo.Provider,{value:{onClickLink:n,href:o}},t)}function _o(){let o=pr(Fo);if(o===void 0)throw new Error("useProductNavigationContext must be used within a ProductNavigationProvider");return o}import ur from"react";var k=({children:o})=>{let{onClickLink:t,href:r}=_o();return ur.createElement("a",{href:r,onClick:t,style:{display:"block"}},o)};import Ko,{css as Zo}from"styled-components";var Qo=Ko.div`
  margin-top: 12px;
  margin-bottom: 12px;
`,G=Ko.div`
  margin-top: 12px;
  margin-bottom: 12px;

  ${({$size:o})=>o==="compact"&&Zo`
      margin-top: 12px;
      margin-bottom: 5px;
    `}

  ${({$size:o})=>o==="large"&&Zo`
      margin-top: 20px;
      margin-bottom: 20px;
    `}
`;import*as v from"react";import{useMediaQueryContext as mr}from"@fourthwall/components/dist/providers/MediaQueryProvider";import{useMemo as Cr}from"react";var co={ACRYLIC_CUTOUT:"Acrylic cutout",ALL_OVER_PRINT:"All over printed",DRINKWARE:"Drinkware",DIE_CUT_MAGNET:"Die cut magnet",DTFX:"DTFx",DTG:"DTG",EMBROIDERY:"Embroidered",GARMENT_PRINTED:"Printed on demand",HOLO_STICKER:"Holographic sticker",KNITTING:"Knitted",OTHER:"Other",PRINTED:"Digital printed",SCREEN_PRINTING:"Screen printed",STICKER:"Sticker",SUBLIMATION:"Sublimation",UV:"UV"};var Pr=()=>{let o=v.useContext(po),r=mr().laptop?2:1;return v.createElement(v.Fragment,null,o.productionMethodsKeys.slice(0,r).map(n=>v.createElement(e.Pill,{key:n},co[n])),o.productionMethodsKeys.length>r&&v.createElement(e.Pill,null,"+",o.productionMethodsKeys.length-r))},hr=({setActiveProductionMethod:o})=>{let t=v.useContext(po);return v.createElement(v.Fragment,null,t.productionMethodsKeys.map(r=>v.createElement(e.Pill,{key:r,onClick:()=>{o(r)}},co[r])))},po=v.createContext(null),V=({product:o,children:t})=>{let r=Cr(()=>({productionMethodsKeys:Object.keys(o.groupedProductionMethods)}),[o.groupedProductionMethods]);return v.createElement(po.Provider,{value:r},v.createElement(e.Pills,null,t))};V.Static=Pr;V.Interactive=hr;var D=({checked:o=!1,interactive:t=!0,product:r,onClickLink:n,href:a,activeProduct:i,setActiveProductionMethod:s})=>d.createElement(e,{interactive:t},d.createElement(N,{href:a,onClickLink:n},d.createElement(e.Body,null,d.createElement(e.Thumbnail,{badges:[],outline:o,alt:`Photo showing ${r.name}`}),d.createElement(e.ContentOnMouseLeave,null,d.createElement(e.Space,{spacing:6},d.createElement(e.Space,{spacing:4},d.createElement(e.Brand,null,t?d.createElement(k,null,`${r.brand} ${r.brandModel}`):d.createElement("p",null,`${r.brand} ${r.brandModel}`)),t?d.createElement(k,null,d.createElement(e.Name,{$hoverable:!0},r.name)):d.createElement(e.Name,{$hoverable:!1},r.name)),d.createElement(e.Space,{spacing:8},d.createElement(V,{product:r},d.createElement(V.Static,null)),d.createElement(e.Price,{price:{from:{value:i.priceFrom,currency:"USD"},to:{value:i.priceTo,currency:"USD"}},minimum:i.minimumOrdersNumber})),d.createElement(G,null,d.createElement(e.AvailableColors,{colorsAvailable:i.colorVariants.matched.map(({color:p})=>p),colorsOther:i.colorVariants.other.map(({color:p})=>p)}))),d.createElement(e.ContentOnMouseEnter,null,d.createElement(e.Space,{spacing:6},d.createElement(e.Space,{spacing:4},d.createElement(e.Brand,null,t?d.createElement(k,null,`${r.brand} ${r.brandModel}`):d.createElement("p",null,`${r.brand} ${r.brandModel}`)),t?d.createElement(k,null,d.createElement(e.Name,null,r.name)):d.createElement(e.Name,{$hoverable:!1},r.name)),d.createElement(e.Space,{spacing:8},d.createElement(V,{product:r},d.createElement(V.Interactive,{setActiveProductionMethod:s})),d.createElement(e.Price,{price:{from:{value:i.priceFrom,currency:"USD"},to:{value:i.priceTo,currency:"USD"}},minimum:i.minimumOrdersNumber})),d.createElement(Qo,null,d.createElement(e.ContentColorway,null)))))))),vr=o=>d.createElement(e.Label,{relative:!0,checked:o.checked,label:o.label,value:o.value,name:o.name,onChange:o.onChange},o.children),fr=o=>d.createElement(e.Radio,{checked:o.checked,label:o.label,value:o.value,name:o.name,onChange:o.onChange},o.children),Sr=o=>d.createElement(e.ZoomInButton,{onClick:o.onClick}),yr=()=>d.createElement(b,{gap:8},d.createElement(gr,{ratio:"7.5:10"},d.createElement(b.Shape,{width:"100%"})),d.createElement(b.Shape,{width:"66%",height:16}),d.createElement(b.Shape,{width:"80%",height:24}),d.createElement(b.Shape,{width:"75%",height:16}),d.createElement(b,{aligment:"horizontal",gap:8},d.createElement(b.Shape,{radius:"50%",width:12,height:12}),d.createElement(b.Shape,{radius:"50%",width:12,height:12}),d.createElement(b.Shape,{radius:"50%",width:12,height:12})));D.Skeleton=xr(yr);D.Label=vr;D.Radio=fr;D.ZoomInButton=Sr;import{AspectBox as Vr}from"@fourthwall/components/dist/common/AspectBox/AspectBox";import{Skeleton as B}from"@fourthwall/components/dist/partials/Skeleton";import P,{memo as br}from"react";var Br=({product:o,size:t="regular",onClickLink:r,href:n,activeProduct:a})=>P.createElement(e,{interactive:!1},P.createElement(N,{href:n,onClickLink:r},P.createElement(e.Body,{compact:!0},P.createElement(e.ThumbnailCompact,{badges:[],outline:!1,alt:`Photo showing ${o.name}`,seed:o.id}),P.createElement(e.Space,{spacing:6},P.createElement(e.Space,{spacing:4},P.createElement(e.Name,{$hoverable:!1,$size:t},o.name)),P.createElement(e.PriceCompact,{size:t,price:{from:{value:a.priceFrom,currency:"USD"},to:{value:a.priceTo,currency:"USD"}}}))))),Mr=()=>P.createElement(B,{gap:8},P.createElement(Vr,{ratio:"7.5:10"},P.createElement(B.Shape,{width:"100%"})),P.createElement(B.Shape,{width:"66%",height:16}),P.createElement(B.Shape,{width:"80%",height:24}),P.createElement(B.Shape,{width:"75%",height:16}),P.createElement(B,{aligment:"horizontal",gap:8},P.createElement(B.Shape,{radius:"50%",width:12,height:12}),P.createElement(B.Shape,{radius:"50%",width:12,height:12}),P.createElement(B.Shape,{radius:"50%",width:12,height:12})));Br.Skeleton=br(Mr);import{AspectBox as zr}from"@fourthwall/components/dist/common/AspectBox/AspectBox";import{Skeleton as M}from"@fourthwall/components/dist/partials/Skeleton";import c,{memo as kr}from"react";import Ar,{css as uo}from"styled-components";import{Colors as H}from"@fourthwall/components/dist/colors";var jo=Ar.div`
  ${({$outline:o})=>o==="heavy"&&uo`
      outline: 2px solid ${H.B500};
    `}

  ${({$outline:o})=>o==="medium"&&uo`
      outline: 1px solid ${H.GS600};
    `}

  ${({$outline:o})=>o==="light"&&uo`
      outline: 1px solid ${H.GS400};

      &:hover {
        outline: 1px solid ${H.GS600};
      }
    `}
`;var wr=({checked:o=!1,product:t,onClickLink:r,onCheckboxChange:n,onZoomInClick:a,href:i,children:s})=>c.createElement(jo,{$outline:o?"heavy":"light"},c.createElement(e,{interactive:!1},c.createElement(N,{href:i,onClickLink:r},c.createElement(e.Label,{showLabelOnHover:!0,outline:!1,checked:o,label:t.name,value:t.id,name:t.name,onChange:n},c.createElement(e.ZoomInButton,{onClick:m=>{m.preventDefault(),a(m)}}),c.createElement(e.Body,null,c.createElement(e.Thumbnail,{badges:[],outline:!1,alt:`Photo showing ${t.name}`}),c.createElement("div",{style:{marginTop:"20px"}},c.createElement(e.HorizontalGutter,{gutter:20},c.createElement(e.Space,{spacing:6},c.createElement(e.Space,{spacing:4},c.createElement(e.Brand,null,c.createElement(k,null,`${t.brand} ${t.brandModel}`)),c.createElement(k,null,c.createElement(e.Name,null,t.name))),c.createElement(e.Space,{spacing:8},c.createElement(V,{product:t},c.createElement(V.Static,null)),c.createElement(e.Price,{price:{from:{value:t.priceFrom,currency:"USD"},to:{value:t.priceTo,currency:"USD"}},minimum:t.minimumOrdersNumber}))))))),c.createElement(e.HorizontalGutter,{gutter:20},c.createElement(G,{$size:"large"},s))))),Tr=()=>c.createElement(M,{gap:8},c.createElement(zr,{ratio:"7.5:10"},c.createElement(M.Shape,{width:"100%"})),c.createElement(M.Shape,{width:"66%",height:16}),c.createElement(M.Shape,{width:"80%",height:24}),c.createElement(M.Shape,{width:"75%",height:16}),c.createElement(M,{aligment:"horizontal",gap:8},c.createElement(M.Shape,{radius:"50%",width:12,height:12}),c.createElement(M.Shape,{radius:"50%",width:12,height:12}),c.createElement(M.Shape,{radius:"50%",width:12,height:12})));wr.Skeleton=kr(Tr);import{useState as $r}from"react";var On=({product:o})=>{let[t,r]=$r(Object.values(o.groupedProductionMethods)?.[0]?.[0]?.productionMethod??null),{activeColorVariant:n}=$(),a=Object.values(o.groupedProductionMethods).flat().find(({productionMethod:s})=>s===t),i=t&&a?a:{slug:o.slug,priceFrom:o.priceFrom,priceTo:o.priceTo,minimumOrdersNumber:o.minimumOrdersNumber,productionMethod:o.productionMethod,colorVariants:o.variants,badges:o.badges};return{product:o,activeProduct:i,activeColorVariant:n,setActiveProductionMethod:r}};import L,{useState as it}from"react";import{Colorway as Fr}from"@fourthwall/components/dist/common/Colorway";import{Gallery as _r}from"@fourthwall/components/dist/common/Gallery/Gallery";import Lr,{createContext as Er,useContext as Or,useMemo as Jo}from"react";import{useMemo as Ir,useState as Nr}from"react";var Yo=(o,t)=>{let[r,n]=Nr(t??o[0]),a=(u,S)=>o.find(I=>I.size===u&&I.color.name===S),i=u=>o.find(S=>S.size===u),s=u=>{n(i(u)??o[0])},p=u=>o.find(S=>S.color.name===u),m=u=>{n(p(u)??o[0])},w=Ir(()=>o.filter(u=>u.size===r.size).map(u=>u.color),[r.size,o]);return{activeVariant:r,setActiveVariant:n,activeVariantColors:w,getVariantBy:a,getVariantBySize:i,setActiveVariantBySize:s,getVariantByColor:p,setActiveVariantByColor:m}};var Xo=Er(void 0);function Fn({variants:o,initialVariant:t,children:r}){let{activeVariant:n,activeVariantColors:a,setActiveVariant:i,getVariantBy:s,getVariantBySize:p,setActiveVariantBySize:m,getVariantByColor:w,setActiveVariantByColor:u}=Yo(o,t??o[0]),S=Jo(()=>[...new Set(o.map(g=>g.size))],[o]),I=Jo(()=>[...new Map(o.map(g=>[g.color.name,g.color])).values()],[o]);return Lr.createElement(Xo.Provider,{value:{variants:o,variantsUniqueSizes:S,variantsUniqueColors:I,activeVariant:n,activeVariantColors:a,setActiveVariant:i,getVariantBy:s,getVariantBySize:p,setActiveVariantBySize:m,getVariantByColor:w,setActiveVariantByColor:u}},r)}function U(){let o=Or(Xo);if(o===void 0)throw new Error("useProductVariantContext must be used within a ProductVariantContextProvider");return o}import{Select as Hr}from"@fourthwall/components/dist/inputs/Select";import ot from"react";import Gr from"styled-components";var Ro=Gr.div`
  max-width: 150px;
`;var tt=({onSizeChange:o})=>{let{variantsUniqueSizes:t,activeVariant:r,setActiveVariant:n,getVariantBySize:a}=U(),i=s=>{n(p=>{let m=a(s);return m?(o?.(m),m):p})};return ot.createElement(Ro,null,ot.createElement(Hr,{label:"Size",options:t.map(s=>({label:s,value:s})),size:"small",value:r.size,onChange:s=>{i(s.target.value)}}))};import{mediaQueries as Ur}from"@fourthwall/components/dist/providers/MediaQueryProvider";import mo from"styled-components";var rt=mo.div`
  position: relative;
`,et=mo.div`
  position: absolute;
  top: 10px;
  right: 10px;
`,nt=mo.div`
  position: absolute;
  top: 10px;
  left: 10px;

  ${Ur.laptop} {
    /* TODO: Temporary hack as to do it properly it
  is required to modify generic <Gallery/> component */
    left: 110px;
  }
`;var ei=({designingType:o})=>{let{activeVariant:t,setActiveVariant:r,variantsUniqueSizes:n,variantsUniqueColors:a,getVariantByColor:i}=U(),[s,p]=it(!1),[m,w]=it(null),u=g=>{w(g),p(!0)},S=()=>{p(!1)},I=g=>{let ut=i(g)??t;r(ut)};return L.createElement(rt,null,L.createElement(_r,{photos:t.photos.map(g=>({image:{url:g.url,width:1536,height:2048},thumbnail:{url:g.thumbnailUrl,width:478,height:637}})),zoom:!0,activePhoto:m,activeModal:s,onClose:S,onClick:u}),o==="PER_SIZE"&&n.length>1&&L.createElement(nt,null,L.createElement(tt,null)),a.length>1&&L.createElement(et,null,L.createElement(Fr,{colors:a.map(g=>({label:g.name,value:g.swatch})),direction:"vertical",activeColor:t.color.name,onChange:g=>{I(g.label)}})))};import h from"react";import{Button as Qr}from"@fourthwall/components/dist/common/Button";import{Colors as qr}from"@fourthwall/components/dist/colors";import{ModalBox as jr}from"@fourthwall/components/dist/partials/ModalBox";import{Skeleton as W}from"@fourthwall/components/dist/partials/Skeleton";import{HeartIcon as Yr}from"@fourthwall/icons";import E from"styled-components";import{Colors as Zr}from"@fourthwall/components/dist/colors";var at=E.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`,dt=E.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`,lt=E.div`
  height: 120px;
  aspect-ratio: 3 / 4;
  background: grey;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`,st=E.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
`,ct=E.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  letter-spacing: 0.14px;
  color: ${Zr.GS600};
`,pt=E.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 24px */
`;var mi=({product:o,disabled:t,isFavorite:r,onAdd:n,onRemove:a,onClose:i})=>{let s=r?qr.GS0:"none",p=async()=>{r?await a?.():await n?.()};return h.createElement(jr,{title:"We suggest using desktop to create your products",onClose:i},h.createElement(at,null,h.createElement("p",null,"Product design is not yet available on mobile. For now, you can add this product to your favorites and continue on a larger screen."),h.createElement(dt,null,h.createElement(lt,null,o?h.createElement("img",{src:o.colorVariants[0].photos[0].thumbnailUrl}):h.createElement(W,null,h.createElement(W.Shape,{width:"100%",height:120}))),h.createElement(st,null,h.createElement(ct,null,o?h.createElement(h.Fragment,null,o.brand," ",o.brandModel):h.createElement(W,null,h.createElement(W.Shape,{width:"50%"}))),h.createElement(pt,null,o.name))),h.createElement(Qr,{leftIcon:h.createElement("div",{style:{color:s}},h.createElement(Yr,{fill:s,width:16,height:16})),label:r?"Favorited":"Favorite",appearance:"primary",size:"large",fullWidth:!0,disabled:t,onClick:p})))};export{mi as AddProductToFavoritesModal,D as ProductBox,wr as ProductBoxCustomizable,Br as ProductBoxStatic,Ie as ProductColorVariantProvider,ei as ProductShowcase,Fn as ProductVariantContextProvider,On as useProductBox,$ as useProductColorVariantContext,U as useProductVariantContext};
//# sourceMappingURL=index.js.map